module.exports = __webpack_public_path__ + "school/img/xuekejiaoyanBg.97aa38ce.jpg";